module.exports = __webpack_public_path__ + "img/lk.a4aef5ec.svg";